module.exports = __webpack_public_path__ + "img/thumbnail_Fossa_j_normal.ed83974c.png";